const LangSignIn = {
	"signIn.signUp._notAMember": ["Not a member?", "មិន​ទាន់​ជា​សមាជិក​?"],
	"signIn.signUp._reward": [
		"JOIN STARBUCKSREWARDS",
		"ចូល​រួម​ជា​សមាជិក​ STARBUCKSREWARDS",
	],
	"signIn.signUp._description": [
		"<p>With a Starbucks Rewards account, you can register your Starbucks Card, manage your account and participate in Starbucks Rewards<sup>TM</sup> program.</p><p>Pay with your registered Starbucks Rewards<sup>TM</sup> Card in any participating Starbucks store to earn Stars.</p><p>Earn one Star for every $0.50 you spend.</p><p>Collect 200 Stars within one year to reach Gold Status.</p>",
		"<p>​ជាមួយ​​​​សមាជិក​ Starbucks Rewards លោក​អ្នក​អាចភ្ជាប់​​កាត​ Starbucks គ្រប់គ្រង​គណនី​របស់​លោក​អ្នក​ និង​​ចូលរួម​កម្មវិធី​សន្សំ​ផ្កាយ​យក​រង្វាន់​ ពី​ Starbucks Rewards<sup>TM</sup> ។</p> <p>បង់​ប្រាក់​​តាម​កាត​​ Starbucks Rewards<sup>TM</sup>​ នៅ​គ្រប់​សាខា​ Starbucks ដើម្បី​សន្សំ​ផ្កាយ​ ។ រាល់​ពេល​ចំណាយ​អស់​ $0.50 នឹង​​ទទួល​បាន​ផ្កាយ​ចំនួន 1  ។</p><p>សន្សំ​​បាន​ 200ផ្កាយ​ ក្នុង​កំឡុង​ពេល​មួយ​ឆ្នាំ នឹង​ក្លាយ​ជា​សមាជិក​មាស ។</p>",
	],
	"signIn.form._forgotPasswordOrEmail": ["Forgot your ", "ភ្លេច​"],
	"signIn.form._email": ["email", "អាសយដ្ឋាន​អ៊ីម៉ែល​​"],
	"signIn.form._password": ["password", "លេខ​សម្ងាត់"],
	"signIn.form._invalidCredential": [
		"Please check your sign-in information and try again. 5 failed attempts before your account will be temporarily locked for 10 mins",
		"សូម​ពិនិត្យ​ព័ត៌មាន​សម្រាប់​​ចូល​​​គណនី​​​​របស់​លោក​អ្នក​ រួច​ព្យាយាម​​ម្តង​ទៀត​ ។ បើ​​​​បញ្ចូល​ព័ត៌មាន​ខុស​​5ដង​ ​គណនី​​របស់​លោក​អ្នក​​​ នឹង​ត្រូវ​បិទ​​ជា​បណ្តោះ​អាសន្ន​ 10​នាទី ។​​",
	],
	"signIn.signUp._pay": ["Pay with your phone", "បង់​ប្រាក់​តាម​ទូរស័ព្ទ"],
	"signIn.signUp._earn": [
		"Earn free Drinks and Food",
		"ទទួល​បាន​ភេសជ្ជៈ និង​ម្ហូប​​ដោយ​ឥត​គិត​ថ្លៃ​",
	],
	"signIn.signUp._exclusive": [
		"Exclusive Member Offer",
		"ការ​ផ្តល់​ជូន​ពិសេស​សម្រាប់​តែ​សមាជិក​",
	],
}

export default LangSignIn



// WEBPACK FOOTER //
// ./src/resources/pages/LangSignIn.js